import { useQuery, useQueryClient } from "@tanstack/react-query";

import { UserListRequest } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";

import { createItemUpdaterForQueryLists } from "./hooks/create-item-updater-for-query-list";
import { QueryListReturn } from "./types/query-return";

export type TenantUserListQueryParams = Omit<UserListRequest, "tenantId">;

// LIST

export function getTenantUserListQuery(params: TenantUserListQueryParams) {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["tenant-users", "list", params],
    queryFn: async () => getRanaApiV1().UsersApi.userList(params),
  });
}

export const useTenantUserListQuery = (params: TenantUserListQueryParams) => {
  return useQuery(getTenantUserListQuery(params));
};

// INVALIDATION

export const useInvalidateTenantUserListQuery = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: getTenantUserListQuery({}).queryKey.slice(0, -1),
      refetchType: "all",
    });
  };
};

export const useUpdateTenantUsersQuery = () => {
  const queryClient = useQueryClient();
  return createItemUpdaterForQueryLists<QueryListReturn<typeof getTenantUserListQuery>>(
    queryClient,
    {
      getQueryKey: () => getTenantUserListQuery({}).queryKey.slice(0, -1),
    }
  );
};
